import React from "react";

const GroupTable = ({ title, rows, mode, monthName }) => {
  const totals = (rows ?? []).reduce(
    (acc, r) => {
      acc.res1 += r.confirmed_Count || 0;
      acc.res2 += r.confirmedBefore_CancelledInM_Count || 0;
      acc.res3 += r.confirmedInM_CancelledInM_Count || 0;

      acc.ppl1 += r.confirmed_People || 0;
      acc.ppl2 += r.confirmedBefore_CancelledInM_People || 0;
      acc.ppl3 += r.confirmedInM_CancelledInM_People || 0;
      return acc;
    },
    { res1: 0, res2: 0, res3: 0, ppl1: 0, ppl2: 0, ppl3: 0 }
  );

  return (
    <section className="ufg-section">
      <div className="ufg-section-header">
        <div className="ufg-section-title">{title}</div>
      </div>

      <div className="table-wrap">
        <table className="ufg-table ufg-table--summary">
          <thead>
            <tr>
              <th>Wycieczka</th>
              <th>Potw.</th>
              <th>Potw. przed i anulowana w {monthName}</th>
              <th>Potw. i anulowana w {monthName}</th>
            </tr>
          </thead>
          <tbody>
            {(rows ?? []).map((r) => (
              <tr key={r.tripGuid}>
                <td>{r.tripName}</td>
                {mode === "res" ? (
                  <>
                    <td>{r.confirmed_Count}</td>
                    <td>{r.confirmedBefore_CancelledInM_Count}</td>
                    <td>{r.confirmedInM_CancelledInM_Count}</td>
                  </>
                ) : (
                  <>
                    <td>{r.confirmed_People}</td>
                    <td>{r.confirmedBefore_CancelledInM_People}</td>
                    <td>{r.confirmedInM_CancelledInM_People}</td>
                  </>
                )}
              </tr>
            ))}

            {(!rows || rows.length === 0) && (
              <tr><td colSpan={4} className="empty">Brak danych</td></tr>
            )}

            {rows && rows.length > 0 && (
              <tr className="ufg-total">
                <td><b>Suma</b></td>
                {mode === "res" ? (
                  <>
                    <td><b>{totals.res1}</b></td>
                    <td><b>{totals.res2}</b></td>
                    <td><b>{totals.res3}</b></td>
                  </>
                ) : (
                  <>
                    <td><b>{totals.ppl1}</b></td>
                    <td><b>{totals.ppl2}</b></td>
                    <td><b>{totals.ppl3}</b></td>
                  </>
                )}
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default GroupTable;
